import { GameID } from '@magicyard/platform-shared/games';

export const DEFAULT_GAME_ID: GameID | undefined = undefined;
export const FIRST_TIME_KEY = 'isFirstTime';
export const MAINTENANCE_MODE = false;
